import { path } from 'ramda'
import { createSelector } from 'reselect'
import { StateInterface } from '../types/states'
import { User } from '../types/users'

const selectUsersDomain = (state: StateInterface) => state.users

const selectCognitoData = createSelector(
  selectUsersDomain,
  (users) => users.cognitoData
)
const selectUsers = createSelector(selectUsersDomain, (users) => users.users)
const selectUsersAsArray =
  createSelector(
    selectUsers,
    (users) => Object.values(users || {}) as User[]
  ) || ([] as User[])

const selectUserByUserId = (userId: string) =>
  createSelector(selectUsers, (users) => {
    return users[userId] as User | undefined
  })

const selectSessionInitializationAttempted = createSelector(
  selectUsersDomain,
  (users) => users.sessionInitializationAttempted
)
const selectIsLoadingSession = createSelector(
  selectUsersDomain,
  (users) => users.isLoadingSession
)
const selectAreUsersLoading = createSelector(
  selectUsersDomain,
  (users) => users.areUsersLoading
)

const selectNotConfirmedEmail = createSelector(
  selectUsersDomain,
  (users) => users.notConfirmedEmail
)

const selectLastUrl = createSelector(
  selectUsersDomain,
  (users) => users.lastUrl
)
const selectIsConfirmingEmail = createSelector(
  selectCognitoData,
  (cognitoData) => cognitoData.isConfirmingEmail
)
const selectUserIsAuthenticated = createSelector(
  selectCognitoData,
  (cognitoData) => cognitoData.isAuthenticated
)
const selectUserId = createSelector(
  selectCognitoData,
  (cognitoData) => cognitoData.sub
)
const selectUserAttributes = createSelector(
  [selectCognitoData, selectUserId, selectUsers],
  (cognitoData, userId, users) => ({
    ...cognitoData.attributes,
    collateralVerified: users[userId]?.collateralVerified
  })
)
const selectUserLanguage = createSelector(selectCognitoData, (cognitoData) =>
  path(['attributes', 'custom:language'], cognitoData)
)
const selectIsAdminUser = createSelector(
  selectCognitoData,
  (cognitoData) => cognitoData.role === 'admin'
)


const selectDevice = createSelector(selectUsersDomain, (users) => users.device)
const selectIsMobile = createSelector(selectDevice, (device) => device.isMobile)
const selectWindowWidth = createSelector(
  selectDevice,
  (device) => device.windowWidth
)

export {
  selectCognitoData,
  selectUsers,
  selectUsersAsArray,
  selectUserByUserId,
  selectSessionInitializationAttempted,
  selectIsLoadingSession,
  selectAreUsersLoading,
  selectNotConfirmedEmail,
  selectIsConfirmingEmail,
  selectUserIsAuthenticated,
  selectLastUrl,
  selectUserAttributes,
  selectUserLanguage,
  selectIsAdminUser,
  selectUserId,
  selectIsMobile,
  selectWindowWidth
}
